import { Mail, Phone, MapPin, Clock, Globe } from "lucide-react";

export const contactData = {
  hero: {
    eyebrow: "Get In Touch",
    title: "Let's Start a Conversation About",
    highlight: "Your Pipeline Growth.",
    description:
      "Whether you need custom B2B data enrichment, dedicated outbound lead generation, or technical staffing solutions, our team is ready to assist.",
  },
  directContacts: [
    {
      icon: Phone,
      label: "Phone",
      value: "+1 786 776 2152",
      href: "tel:+17867762152",
      subtext: "Mon-Fri from 9am to 6pm EST",
    },
    {
      icon: Mail,
      label: "Email",
      value: "info@conectify-tech.com",
      href: "mailto:info@conectify-tech.com",
      subtext: "Online support & general inquiries",
    },
    {
      icon: Clock,
      label: "Response Time",
      value: " 24 Hours",
      subtext: "Fast turnarounds on custom quotes",
    },
  ],
  offices: [
    {
      region: "India (HQ)",
      flag: "🇮🇳",
      icon: Globe,
      addressIcon: MapPin,
      address: "Mount Motor Gali, Ratu Road, Alkapuri, Near Kidzee School",
      city: "Ranchi - 834001, Jharkhand",
      country: "India",
      tag: "Global Operations & Delivery Center",
    },
    {
      region: "United States",
      flag: "🇺🇸",
      icon: Globe,
      addressIcon: MapPin,
      address: "1000 Brickell Ave Ste",
      city: "Miami, FL 33131",
      country: "USA",
      tag: "Americas Business Development",
    },
  ],
};